import { render } from "./SendView.vue?vue&type=template&id=7d7af8d8&scoped=true"
import script from "./SendView.vue?vue&type=script&lang=js"
export * from "./SendView.vue?vue&type=script&lang=js"

import "./SendView.vue?vue&type=style&index=0&id=7d7af8d8&lang=css"
import "./SendView.vue?vue&type=style&index=1&id=7d7af8d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7af8d8"]])

export default __exports__